import React from "react";

import EditVendorProfile from "app/vendors/modules/generic/feature/edit/edit";

const AdminProviderEdit = () => {
  return (
    <>
      <EditVendorProfile />
    </>
  );
};

export default AdminProviderEdit;
